import React__default from 'react';
import { OrderGroupProductTypeEnum } from '@invitae/stargate-ts-fetch';
import { testPageUrl } from '../../../utils/constants/urls.esm.js';
import { cleanUpCodeForLinkUrl } from '../OrderCard.utils.esm.js';
import Test from '../Test.esm.js';
import styles from './TestSelection.module.esm.js';

var TestSelectionList = function (_a) {
    var handleDeleteTest = _a.handleDeleteTest, isCompact = _a.isCompact, productType = _a.productType, testSelections = _a.testSelections;
    return (React__default.createElement(React__default.Fragment, null, testSelections.map(function (test) {
        var _a;
        var shouldHideGenes = productType === OrderGroupProductTypeEnum.Nips;
        var testUrl = test.code && testPageUrl + cleanUpCodeForLinkUrl(test.code);
        return (React__default.createElement("div", { className: isCompact ? styles.mainInfoWrapperCompact : styles.mainInfoWrapper, key: "".concat(test.code, "_").concat(test.name) },
            React__default.createElement(Test, { handleDeleteTest: handleDeleteTest, hideGenes: shouldHideGenes, test: test, productType: productType, url: testUrl }), (_a = test === null || test === void 0 ? void 0 : test.addOns) === null || _a === void 0 ? void 0 :
            _a.map(function (addOn) { return (React__default.createElement(Test, { handleDeleteTest: handleDeleteTest, hideGenes: shouldHideGenes, isAddon: true, key: "".concat(addOn.code), productType: productType, test: addOn, url: testUrl })); })));
    })));
};

export { TestSelectionList as default };
//# sourceMappingURL=TestSelectionList.esm.js.map
